import {BORDER, Button, FONT_WEIGHTS} from '@aboutyou/ui-components';
import React, {FC} from 'react';

import {styled} from '@linaria/react';
import {Languages as LanguagesType} from '../LanguageCountrySwitch';

export const Languages: FC<{className?: string; languages: LanguagesType}> = ({
  className,
  languages,
}) => {
  return (
    <Wrapper className={className} data-testid="languageCountrySwitchLanguages">
      {languages.map(({isSelected, label, linkTarget, onClick}) => {
        const key = `languageCountrySwitchLanguage-${label}`;

        return (
          <Language
            data-testid={key}
            data-is-selected={isSelected}
            key={key}
            openExternalLinkInNewTab={false}
            href={linkTarget}
            onClick={onClick}
            variant="secondary"
          >
            {label}
          </Language>
        );
      })}
    </Wrapper>
  );
};

const Wrapper = styled.div`
  align-items: center;
  box-sizing: border-box;
  display: flex;
  gap: 0.5rem;
  justify-content: center;
  width: 100%;
  flex-wrap: wrap;
`;

const Language = styled(Button)<{$isSelected?: boolean}>`
  &[data-is-selected='true'] {
    --border-width: ${BORDER.Lg};
  }

  flex: 1 1 calc(50% - 0.5rem); /* Two items per row with gap adjustment */
  max-width: 50%;
  font-size: 0.8125rem;
  font-weight: ${FONT_WEIGHTS.bold};
  height: 2.5rem;
`;
